module.exports = __webpack_public_path__ + "static/media/camara.3aafbc26.svg";